/**
 * Finds the object with the given id in the given tree of objects that may
 * have children.
 *
 * @param {object} tree
 * @param {number} id
 * @returns {object|null}
 */
export function findInTree (tree, key, value) {
  if (tree[key] === value) {
    return tree
  }

  if (tree.children && Array.isArray(tree.children)) {
    for (const child of tree.children) {
      const result = findInTree(child, key, value)

      if (result) {
        return result
      }
    }
  }

  return null
}
